import React from 'react';

import { Page } from 'components/modules/AutoruLayout/Page/Page';
import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';

import { Stepper } from '../Stepper/Stepper';

export const Payment = () => {
  return (
    <Page aside={<Stepper />}>
      <PageContent title="TODO: Поделить роут на подроуты"></PageContent>
    </Page>
  );
};
